import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

import { Arrows } from '@components/Slider';

const contentSizeCss = css`
  max-height: 18.75rem !important;
  max-width: calc(100vw - 40px) !important;
  margin: auto;
`;

export const ImageSliderWrapper = styled.div<{ newPdDesign: boolean }>`
  ${({ newPdDesign }) =>
    newPdDesign
      ? css`
          position: relative;
          left: -0.9375rem;
          // prettier-ignore
          width: calc(100% + 1.875rem); // 0.9375rem padding is added by pdp container
          background-color: ${theme.palette.neutralLighter};
          margin-bottom: 1.25rem;
          aspect-ratio: 1 / 1;
          @media (min-width: ${breakpoints.lg}) {
            display: none;
          }
          .slick-track {
            display: flex;
            align-items: center;
          }
          .slick-slide {
            height: 100%;

            > div {
              height: 100%;
            }
          }
        `
      : css`
          @media (min-width: ${breakpoints.md}) {
            display: none;
          }
        `}
`;

export const PlayerWrapper = styled.div<{ newPdDesign: boolean }>`
  ${({ newPdDesign }) =>
    newPdDesign
      ? css`
          display: flex !important; // rewrite styles from react-slick
          align-items: center;

          height: 100%;
          iframe {
            ${contentSizeCss}
          }
        `
      : css`
          ${contentSizeCss}
          iframe {
            ${contentSizeCss}
          }
        `}
`;

export const ImgWrapper = styled.div<{
  newPdDesign: boolean;
  isSquare?: boolean;
}>`
  height: 100%;
  position: relative;

  margin: auto;

  ${({ newPdDesign, isSquare }) =>
    newPdDesign
      ? css`
          background-color: ${theme.palette.neutralLighter};
          max-width: 100vw;
          margin: auto;

          ${isSquare
            ? css`
                > div:first-child {
                  height: 100%;
                }
                img {
                  width: 100%;
                  height: 100%;
                }
              `
            : css`
                padding: 0 2.25rem;
                height: 100%;
                img {
                  width: auto;
                  max-width: 100% !important;
                  height: auto;
                  max-height: min(21.875rem, 80%) !important;
                }
                > div:first-child {
                  // use first-child so we don't target modiface overlay
                  max-height: 100%;
                }
              `}

          @media (min-width: ${breakpoints.md}) {
            height: 100%;
          }
          img {
            mix-blend-mode: darken;
            min-height: auto;

            max-height: 100%;
          }
        `
      : css`
          height: 18.75rem;
          ${contentSizeCss};

          padding-left: 1.25rem;
          padding-right: 1.25rem;
          img {
            width: auto;
            max-width: 100% !important;
            height: auto;
            max-height: 100% !important;
            @media (min-width: ${breakpoints.md}) {
              height: 100%;
              width: auto;
              max-width: unset;
            }
          }
        `}
`;

export const StyledArrow = styled(Arrows)<{ newPdDesign: boolean }>`
  ${({ newPdDesign }) =>
    newPdDesign &&
    css`
      background-color: ${theme.palette.transparent};
      height: 3rem;
      width: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;
